(() => {
  const tableSelector = [
    '.rte table:not([class])',
    '.product__description table:not([class])',
    '.product-popup-modal__content table:not([class])',
    '.metafield-rich_text_field table:not([class])',
  ].join(',');

  const wrapTables = (root = document) => {
    root.querySelectorAll(tableSelector).forEach((table) => {
      if (table.closest('.dibao-table-scroll')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'dibao-table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('aria-label', 'Scrollable table');

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => wrapTables());
  } else {
    wrapTables();
  }

  document.addEventListener('shopify:section:load', (event) => wrapTables(event.target));
})();
